// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/password_push/v1/password_push_invocation_search.proto" (package "c1.api.password_push.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Any } from "../../../../google/protobuf/any";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushInvocationTarget
 */
export interface PasswordPushInvocationTarget {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2;
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string app_user_id = 3;
     */
    appUserId: string;
    /**
     * @generated from protobuf field: c1.api.password_push.v1.PasswordPushInvocationTaskStatus status = 4;
     */
    status: PasswordPushInvocationTaskStatus;
    /**
     * @generated from protobuf field: string error_message = 5;
     */
    errorMessage: string;
}
/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushInvocationTargetStateRef
 */
export interface PasswordPushInvocationTargetStateRef {
    /**
     * @generated from protobuf field: string password_push_invocation_id = 1;
     */
    passwordPushInvocationId: string;
    /**
     * @generated from protobuf field: string app_id = 2;
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 3;
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string app_user_id = 4;
     */
    appUserId: string;
}
/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushInvocationTargetState
 */
export interface PasswordPushInvocationTargetState {
    /**
     * @generated from protobuf field: string password_push_invocation_id = 1;
     */
    passwordPushInvocationId: string;
    /**
     * @generated from protobuf field: string app_id = 2;
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 3;
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string app_user_id = 4;
     */
    appUserId: string;
    /**
     * @generated from protobuf field: c1.api.password_push.v1.PasswordPushInvocationTaskStatus status = 5;
     */
    status: PasswordPushInvocationTaskStatus;
    /**
     * @generated from protobuf field: string error_message = 6;
     */
    errorMessage: string;
    /**
     * @generated from protobuf field: int32 retry_attempts = 7;
     */
    retryAttempts: number;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 8;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 9;
     */
    updatedAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushInvocationRef
 */
export interface PasswordPushInvocationRef {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushInvocation
 */
export interface PasswordPushInvocation {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string password_push_flow_id = 2;
     */
    passwordPushFlowId: string;
    /**
     * @generated from protobuf field: string user_id = 3;
     */
    userId: string;
    /**
     * @generated from protobuf field: c1.api.password_push.v1.PasswordPushInvocationStatus status = 5;
     */
    status: PasswordPushInvocationStatus;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 6;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 7;
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: string error_message = 8;
     */
    errorMessage: string;
}
/**
 * The supported paths are 'user_id', 'password_push_flow_id'
 *
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushInvocationExpandMask
 */
export interface PasswordPushInvocationExpandMask {
    /**
     * An array of paths to be expanded in the response.
     *
     * @generated from protobuf field: repeated string paths = 1;
     */
    paths: string[];
}
// ====== Search ======

/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushInvocationSearchServiceRequest
 */
export interface PasswordPushInvocationSearchServiceRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string query = 3;
     */
    query: string;
    /**
     * @generated from protobuf field: repeated c1.api.password_push.v1.PasswordPushInvocationRef refs = 4;
     */
    refs: PasswordPushInvocationRef[];
    /**
     * @generated from protobuf field: repeated c1.api.password_push.v1.PasswordPushInvocationStatus statuses = 5;
     */
    statuses: PasswordPushInvocationStatus[];
    /**
     * @generated from protobuf field: repeated string user_ids = 6;
     */
    userIds: string[];
    /**
     * @generated from protobuf field: string password_push_flow_id = 7;
     */
    passwordPushFlowId: string;
    /**
     * @generated from protobuf field: c1.api.password_push.v1.PasswordPushInvocationExpandMask expand_mask = 8;
     */
    expandMask?: PasswordPushInvocationExpandMask;
}
/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushInvocationSearchServiceResponse
 */
export interface PasswordPushInvocationSearchServiceResponse {
    /**
     * The list of results containing up to X results, where X is the page size defined in the request
     *
     * @generated from protobuf field: repeated c1.api.password_push.v1.PasswordPushInvocationView list = 1;
     */
    list: PasswordPushInvocationView[];
    /**
     * List of related objects
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size. The server returns one page of results and the nextPageToken until all results are retreived. To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: string next_page_token = 3;
     */
    nextPageToken: string;
}
// ====== Get Latest Password Push Invocation For User ======

/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushInvocationSearchServiceGetLatestForUserRequest
 */
export interface PasswordPushInvocationSearchServiceGetLatestForUserRequest {
    /**
     * @generated from protobuf field: string user_id = 1;
     */
    userId: string;
    /**
     * @generated from protobuf field: string password_push_flow_id = 2;
     */
    passwordPushFlowId: string;
}
/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushInvocationSearchServiceGetLatestForUserResponse
 */
export interface PasswordPushInvocationSearchServiceGetLatestForUserResponse {
    /**
     * @generated from protobuf field: c1.api.password_push.v1.PasswordPushInvocation invocation = 1;
     */
    invocation?: PasswordPushInvocation;
}
// ====== Get Target States For Invocation ======

/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushInvocationSearchServiceGetTargetStatesRequest
 */
export interface PasswordPushInvocationSearchServiceGetTargetStatesRequest {
    /**
     * @generated from protobuf field: string password_push_invocation_id = 1;
     */
    passwordPushInvocationId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: repeated c1.api.password_push.v1.PasswordPushInvocationTargetStateRef refs = 4;
     */
    refs: PasswordPushInvocationTargetStateRef[];
}
/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushInvocationSearchServiceGetTargetStatesResponse
 */
export interface PasswordPushInvocationSearchServiceGetTargetStatesResponse {
    /**
     * @generated from protobuf field: repeated c1.api.password_push.v1.PasswordPushInvocationTargetState list = 1;
     */
    list: PasswordPushInvocationTargetState[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
// ====== View ======

/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushInvocationView
 */
export interface PasswordPushInvocationView {
    /**
     * @generated from protobuf field: c1.api.password_push.v1.PasswordPushInvocation invocation = 1;
     */
    invocation?: PasswordPushInvocation;
    /**
     * JSONPATH expression indicating the location of the User object in the expanded array
     *
     * @generated from protobuf field: string user_path = 2;
     */
    userPath: string;
    /**
     * JSONPATH expression indicating the location of the PasswordPushFlow object in the expanded array
     *
     * @generated from protobuf field: string password_push_flow_path = 3;
     */
    passwordPushFlowPath: string;
}
// ====== Messages ======

/**
 * @generated from protobuf enum c1.api.password_push.v1.PasswordPushInvocationTaskStatus
 */
export enum PasswordPushInvocationTaskStatus {
    /**
     * @generated from protobuf enum value: PASSWORD_PUSH_INVOCATION_TASK_STATUS_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: PASSWORD_PUSH_INVOCATION_TASK_STATUS_SUCCESS = 1;
     */
    SUCCESS = 1,
    /**
     * @generated from protobuf enum value: PASSWORD_PUSH_INVOCATION_TASK_STATUS_ERROR = 2;
     */
    ERROR = 2
}
/**
 * @generated from protobuf enum c1.api.password_push.v1.PasswordPushInvocationStatus
 */
export enum PasswordPushInvocationStatus {
    /**
     * @generated from protobuf enum value: PASSWORD_PUSH_INVOCATION_STATUS_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: PASSWORD_PUSH_INVOCATION_STATUS_RUNNING = 1;
     */
    RUNNING = 1,
    /**
     * @generated from protobuf enum value: PASSWORD_PUSH_INVOCATION_STATUS_SUCCESS = 2;
     */
    SUCCESS = 2,
    /**
     * @generated from protobuf enum value: PASSWORD_PUSH_INVOCATION_STATUS_ERROR = 3;
     */
    ERROR = 3
}
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushInvocationTarget$Type extends MessageType<PasswordPushInvocationTarget> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushInvocationTarget", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "status", kind: "enum", T: () => ["c1.api.password_push.v1.PasswordPushInvocationTaskStatus", PasswordPushInvocationTaskStatus, "PASSWORD_PUSH_INVOCATION_TASK_STATUS_"] },
            { no: 5, name: "error_message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushInvocationTarget
 */
export const PasswordPushInvocationTarget = new PasswordPushInvocationTarget$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushInvocationTargetStateRef$Type extends MessageType<PasswordPushInvocationTargetStateRef> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushInvocationTargetStateRef", [
            { no: 1, name: "password_push_invocation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushInvocationTargetStateRef
 */
export const PasswordPushInvocationTargetStateRef = new PasswordPushInvocationTargetStateRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushInvocationTargetState$Type extends MessageType<PasswordPushInvocationTargetState> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushInvocationTargetState", [
            { no: 1, name: "password_push_invocation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "status", kind: "enum", T: () => ["c1.api.password_push.v1.PasswordPushInvocationTaskStatus", PasswordPushInvocationTaskStatus, "PASSWORD_PUSH_INVOCATION_TASK_STATUS_"] },
            { no: 6, name: "error_message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "retry_attempts", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 9, name: "updated_at", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushInvocationTargetState
 */
export const PasswordPushInvocationTargetState = new PasswordPushInvocationTargetState$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushInvocationRef$Type extends MessageType<PasswordPushInvocationRef> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushInvocationRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushInvocationRef
 */
export const PasswordPushInvocationRef = new PasswordPushInvocationRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushInvocation$Type extends MessageType<PasswordPushInvocation> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushInvocation", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "password_push_flow_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "status", kind: "enum", T: () => ["c1.api.password_push.v1.PasswordPushInvocationStatus", PasswordPushInvocationStatus, "PASSWORD_PUSH_INVOCATION_STATUS_"] },
            { no: 6, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 7, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 8, name: "error_message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushInvocation
 */
export const PasswordPushInvocation = new PasswordPushInvocation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushInvocationExpandMask$Type extends MessageType<PasswordPushInvocationExpandMask> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushInvocationExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "user_id", "password_push_flow_id"] } }, ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushInvocationExpandMask
 */
export const PasswordPushInvocationExpandMask = new PasswordPushInvocationExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushInvocationSearchServiceRequest$Type extends MessageType<PasswordPushInvocationSearchServiceRequest> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushInvocationSearchServiceRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PasswordPushInvocationRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 5, name: "statuses", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.password_push.v1.PasswordPushInvocationStatus", PasswordPushInvocationStatus, "PASSWORD_PUSH_INVOCATION_STATUS_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { enum: { definedOnly: true } } } } } },
            { no: 6, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 7, name: "password_push_flow_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 8, name: "expand_mask", kind: "message", T: () => PasswordPushInvocationExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushInvocationSearchServiceRequest
 */
export const PasswordPushInvocationSearchServiceRequest = new PasswordPushInvocationSearchServiceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushInvocationSearchServiceResponse$Type extends MessageType<PasswordPushInvocationSearchServiceResponse> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushInvocationSearchServiceResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PasswordPushInvocationView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushInvocationSearchServiceResponse
 */
export const PasswordPushInvocationSearchServiceResponse = new PasswordPushInvocationSearchServiceResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushInvocationSearchServiceGetLatestForUserRequest$Type extends MessageType<PasswordPushInvocationSearchServiceGetLatestForUserRequest> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushInvocationSearchServiceGetLatestForUserRequest", [
            { no: 1, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "password_push_flow_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushInvocationSearchServiceGetLatestForUserRequest
 */
export const PasswordPushInvocationSearchServiceGetLatestForUserRequest = new PasswordPushInvocationSearchServiceGetLatestForUserRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushInvocationSearchServiceGetLatestForUserResponse$Type extends MessageType<PasswordPushInvocationSearchServiceGetLatestForUserResponse> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushInvocationSearchServiceGetLatestForUserResponse", [
            { no: 1, name: "invocation", kind: "message", T: () => PasswordPushInvocation }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushInvocationSearchServiceGetLatestForUserResponse
 */
export const PasswordPushInvocationSearchServiceGetLatestForUserResponse = new PasswordPushInvocationSearchServiceGetLatestForUserResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushInvocationSearchServiceGetTargetStatesRequest$Type extends MessageType<PasswordPushInvocationSearchServiceGetTargetStatesRequest> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushInvocationSearchServiceGetTargetStatesRequest", [
            { no: 1, name: "password_push_invocation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PasswordPushInvocationTargetStateRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushInvocationSearchServiceGetTargetStatesRequest
 */
export const PasswordPushInvocationSearchServiceGetTargetStatesRequest = new PasswordPushInvocationSearchServiceGetTargetStatesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushInvocationSearchServiceGetTargetStatesResponse$Type extends MessageType<PasswordPushInvocationSearchServiceGetTargetStatesResponse> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushInvocationSearchServiceGetTargetStatesResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PasswordPushInvocationTargetState },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushInvocationSearchServiceGetTargetStatesResponse
 */
export const PasswordPushInvocationSearchServiceGetTargetStatesResponse = new PasswordPushInvocationSearchServiceGetTargetStatesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushInvocationView$Type extends MessageType<PasswordPushInvocationView> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushInvocationView", [
            { no: 1, name: "invocation", kind: "message", T: () => PasswordPushInvocation },
            { no: 2, name: "user_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "password_push_flow_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushInvocationView
 */
export const PasswordPushInvocationView = new PasswordPushInvocationView$Type();
/**
 * @generated ServiceType for protobuf service c1.api.password_push.v1.PasswordPushInvocationSearchService
 */
export const PasswordPushInvocationSearchService = new ServiceType("c1.api.password_push.v1.PasswordPushInvocationSearchService", [
    { name: "Search", options: { "authz.method": { role: "VIEWER" } }, I: PasswordPushInvocationSearchServiceRequest, O: PasswordPushInvocationSearchServiceResponse },
    { name: "GetLatestForUser", options: { "authz.method": { role: "VIEWER" } }, I: PasswordPushInvocationSearchServiceGetLatestForUserRequest, O: PasswordPushInvocationSearchServiceGetLatestForUserResponse },
    { name: "GetTargetStates", options: { "authz.method": { role: "VIEWER" } }, I: PasswordPushInvocationSearchServiceGetTargetStatesRequest, O: PasswordPushInvocationSearchServiceGetTargetStatesResponse }
]);
